import { BaseProxy } from "@/proxies/BaseProxy";

export class ThreadStatusUpdateProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `changeRequestStatus`,
      parameters,
    });
  }
}

